/**
 * /oauth/email/callback
 *
 * Registered as the redirect URI in Google Cloud Console and Azure AD
 * for the email mailbox OAuth connection flow.
 *
 * When Google/Microsoft redirects back here with ?code=, this page reads
 * the code and state from the URL and posts them to the opener window via
 * postMessage, then closes itself. The useEmailOAuth hook in the opener
 * window receives the message and exchanges the code for tokens via the
 * backend API.
 *
 * If opened as top-level navigation (not a popup), redirects to settings.
 */
import { useEffect } from 'react';

export default function OAuthEmailCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code   = params.get('code')  ?? '';
    const state  = params.get('state') ?? '';
    const error  = params.get('error') ?? '';

    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        { type: 'OAUTH_EMAIL_CALLBACK', code, state, error },
        window.location.origin,
      );
      setTimeout(() => window.close(), 300);
    } else {
      // Opened as top-level navigation — redirect to settings
      window.location.replace('/app/settings?tab=Email+Setup');
    }
  }, []);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: '#f9fafb' }}>
      <p style={{ color: '#6b7280', fontSize: 14, fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif' }}>
        Connecting mailbox… you can close this window.
      </p>
    </div>
  );
}
